import { useEffect, useState } from "react";

const imgUrl = "/images/tactsuit/tactsleeve/scroll-interaction";
const TACT_SLEEVE_IMG_COUNT = 100;

export const useInteractionScrollImgLoaded = () => {
  const [images, setImages] = useState<HTMLImageElement[]>([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // 클라이언트 측에서만 이미지 로드
    const loadImages = async () => {
      const loadedImages: HTMLImageElement[] = [];

      const imagePromises = Array.from(
        { length: TACT_SLEEVE_IMG_COUNT },
        (_, i) => {
          const img = new Image();

          img.src = `${imgUrl}/Sleeve_${i}.webp`;
          loadedImages.push(img);

          return new Promise<void>((resolve) => {
            img.onload = () => resolve();
            img.onerror = () => {
              //img 로드 실패시 .jpg 다시시도
              img.src = `${imgUrl}/Sleeve_${i}.jpg`;
              img.onload = () => resolve();
              img.onerror = () => resolve();
            };
          });
        },
      );

      await Promise.all(imagePromises);

      setImages(loadedImages);
      setIsLoaded(true);
    };

    loadImages();
  }, []);

  return {
    images,
    isLoaded,
  };
};
